export const useQuery = () => {
  const query = new URLSearchParams(window.location.search);
  return {
    getAll(keys: string[]) {
      const values = keys.map((el) => {
        return query.get(String(el));
      });
      return values;
    },
  };
};
